export default __webpack_public_path__ + "d2dfd1cfa325e9c35b2fd5fd411d9bd7.png";